/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view-filter/shop.view-filter.component.ts.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ShopViewComponent} from '../view/shop.view.component';
import {View} from '../../../../models/view';

/**
 * Zweck: Beschreibt class ShopViewFilterComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'shop-view-filter',
    templateUrl: 'shop.view-filter.component.html',
    styleUrls: ['shop.view-filter.component.scss'],
    standalone: false
})
export class ShopViewFilterComponent {
  @Input() view: View;
  @Output() viewChange = new EventEmitter<View>();
  @Output() change = new EventEmitter();
  @Input() viewcomp: ShopViewComponent;

/**
 * Beschreibt Methode doChange und ihren Rückgabevertrag.
 */
  doChange() {
    this.viewChange.emit(this.view);
    this.change.emit();
  }

}
